import { useCssVars as _useCssVars } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-194f7694"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "packageComponent_popover"
};
const _hoisted_2 = {
  class: "card_content"
};
const _hoisted_3 = {
  class: "card_text"
};
const _hoisted_4 = {
  class: "packageComponent_wrap"
};
const _hoisted_5 = ["src", "alt"];
const __default__ = {
  name: 'CMHComponent' // 设置组件名为文件名
  // 组件其他配置...
};

import { getPackageConfig } from '@/assets/api/vip';
import { useStore } from 'vuex';
import { computed, watch, ref } from 'vue';
import { ElMessage } from 'element-plus';
import moment from 'moment';
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    _useCssVars(_ctx => ({
      "106b6a52": filterPackage().background,
      "38214126": filterPackage().textColor
    }));
    const myStore = useStore();
    // 失效时间
    const disabledDate = computed(() => moment(myStore.getters.stationInfo.disableddate).format('YYYY-MM-DD'));
    // 当前渠道的套餐
    const currentPackage = computed(() => myStore.getters.stationInfo.package);
    // 是否是渠道
    const isChannel = computed(() => myStore.getters.userType == 1);
    const currentPackageConfig = ref({});
    // 根据参数，返回不同的参数配置
    const filterPackage = () => {
      const packageMap = {
        1: {
          name: '企业基础版',
          icon: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/icon1/PSOMYQBN20240325020001',
          background: 'linear-gradient( 90deg, #8097CE 0%, #5F78B7 100%)',
          textColor: '#FFFFFF',
          packageCardBg: 'linear-gradient( 90deg, #8097CE 0%, #5F78B7 100%)',
          packageCardTextColor: '#FFFFFF'
        },
        2: {
          name: '企业标准版',
          icon: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/icon1/PSOMYQBN20240325020001',
          background: 'linear-gradient( 90deg, #A1A2C7 0%, #5C6090 100%)',
          textColor: '#FFFFFF',
          packageCardBg: 'linear-gradient( 90deg, #A1A2C7 0%, #5C6090 100%)',
          packageCardTextColor: '#FFFFFF'
        },
        3: {
          name: '企业高级版',
          icon: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/icon2/VRTYYFRJ20240325020004',
          background: 'linear-gradient( 90deg, #FEF8F3 0%, #F4E8DD 100%)',
          textColor: '#C99E72',
          packageCardBg: 'linear-gradient( 90deg, #FEF8F3 0%, #F4E8DD 100%)',
          packageCardTextColor: '#C99E72'
        },
        4: {
          name: '企业尊享版',
          icon: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/icon2/VRTYYFRJ20240325020004',
          background: 'linear-gradient( 90deg, #4D505B 0%, #222223 100%)',
          textColor: '#E8CDAD',
          packageCardBg: 'linear-gradient( 90deg, #4D505B 0%, #222223 100%)',
          packageCardTextColor: '#E8CDAD'
        },
        6: {
          name: '基础版',
          icon: "http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/BJFPODLT20250213032041",
          background: 'linear-gradient( 90deg, #F7D9AF 0%, #E8C28F 100%)',
          textColor: '#673E1E',
          packageCardBg: 'linear-gradient( 90deg, #F7D9AF 0%, #E8C28F 100%)',
          packageCardTextColor: '#673E1E'
        },
        7: {
          name: '行业版',
          icon: "http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/QDCHJDOJ20250213032035",
          background: 'linear-gradient( 90deg, #4E90F9 0%, #2661F3 100%)',
          textColor: '#FFFFFF',
          packageCardBg: 'linear-gradient( 90deg, #4E90F9 0%, #2661F3 100%)',
          packageCardTextColor: '#FFFFFF'
        },
        8: {
          name: '畅享版',
          icon: "http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/QPRJODSZ20250213032038",
          background: 'linear-gradient( 90deg, #4D505B 0%, #222223 100%)',
          textColor: '#E8CDAD',
          packageCardBg: 'linear-gradient( 90deg, #4D505B 0%, #222223 100%)',
          packageCardTextColor: '#E8CDAD'
        }
      };
      return packageMap[currentPackage.value] || {};
    };
    // 获取所有套餐信息
    const handleGetPackageConfig = async () => {
      const res = await getPackageConfig();
      if (res.code != 200) return ElMessage.error(res.message);
      currentPackageConfig.value = res.data.find(v => v.id == currentPackage.value);
      // console.log('currentPackageConfig', currentPackageConfig.value)
    };
    // 格式化有效时间
    const filterDisabledDate = () => {
      // 如果时间小于等于 30 天，就返回剩余天数，否则返回日期
      const currentDate = moment().format('YYYY-MM-DD');
      if (moment(disabledDate.value).diff(currentDate, 'days') <= 30) {
        return `服务仅剩 ${moment(disabledDate.value).diff(currentDate, 'days')} 天到期`;
      } else {
        return `有效期至：${moment(disabledDate.value).format('YYYY-MM-DD')}`;
      }
    };
    watch(currentPackage, () => {
      if (currentPackage.value) {
        handleGetPackageConfig();
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_popover = _resolveComponent("el-popover");
      return _unref(currentPackage) && _unref(isChannel) ? (_openBlock(), _createBlock(_component_el_popover, {
        key: 0,
        width: 280,
        trigger: "click"
      }, {
        reference: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
          src: filterPackage().icon,
          alt: filterPackage().name
        }, null, 8, _hoisted_5), _createElementVNode("span", null, _toDisplayString(filterPackage().name), 1)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
          class: "package_card",
          style: _normalizeStyle({
            background: filterPackage().packageCardBg
          })
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
          class: "card_title",
          style: _normalizeStyle({
            color: filterPackage().packageCardTextColor
          })
        }, _toDisplayString(filterPackage().name), 5), _createElementVNode("div", {
          class: "card_desc",
          style: _normalizeStyle({
            color: filterPackage().packageCardTextColor
          })
        }, _toDisplayString(filterDisabledDate()), 5)])])], 4)])]),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});